const blockReferences = () => {
  const blockReferences = document.querySelectorAll('.block-references');

  blockReferences?.forEach((blockReference) => {
    const content = blockReference.querySelector('.content');
    const toggleButton = blockReference.querySelector('.btn-accordion');
    toggleButton?.addEventListener('click', () => {
      content?.classList.toggle('active');
    });
  });
};

export default blockReferences;
